import * as React from 'react';

export interface IVideo {
    external_url_large: string;
    external_url_small: string;
    id_product_concrete: number;
    id_product_image: number;
    set_id: string;
    title: string;
}

export interface IVideosProps {
    videos?: IVideo[];
}

export const Videos: React.FunctionComponent<IVideosProps> = props => {
    const { videos } = props;

    return (
        <>
            {
                videos.map(video => {
                    return <React.Fragment key={video.id_product_image}>
                        <h4>{video.title}</h4>
                        <video controls preload="none" poster={`${video.external_url_small}.jpg`} aria-describedby="pdp-description-text">
                            <source src={`${video.external_url_small}.m4v`} type="video/x-m4v" />
                            <source src={`${video.external_url_small}.webm`} type="video/webm" />
                            <source src={`${video.external_url_small}.ogv`} type="video/ogg" />
                        </video>
                    </React.Fragment>;
                })
            }
        </>
    );
}
